import { c as _c } from "react/compiler-runtime";
import type { Person } from "@/types/movies";
import Link from "next/link";
import { slugify } from "@/lib/slugify";
import { isCastLikeRole } from "@/lib/roleLabels";
interface Props {
  stars: Person[];
}
export default function MovieCredits(t0) {
  const $ = _c(20);
  const {
    stars
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== stars) {
    const actors = stars.filter(_temp).slice(0, 3);
    const authors = stars.filter(_temp2);
    t4 = "mt-4 space-y-3 text-xs sm:text-sm text-gray-300 max-w-[500px]";
    const t6 = "hidden lg:flex flex-wrap gap-x-1";
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <span className="sm:text-sm lg:text-md font-bold me-2 text-gray-400">کارگردان:</span>;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    const t8 = authors.length > 0 ? authors.map((author, i) => {
      const label = author.name_fa ?? author.name_en ?? "\u2014";
      const nameSlug = slugify(author.name_en || author.name_fa);
      const href = author.uuid ? `/crew/${author.uuid}${nameSlug ? `/${nameSlug}` : ""}` : "#";
      const key = author.uuid ?? `${label}-${i}`;
      return <span key={key}><Link href={href} className="hover:underline text-sm text-white">{label}</Link>{i < authors.length - 1 && "\u060C "}</span>;
    }) : <span>-</span>;
    if ($[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
      t5 = <div className={t6}>{t7}{t8}</div>;
      $[7] = t6;
      $[8] = t7;
      $[9] = t8;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t1 = "hidden lg:flex flex-wrap gap-x-1";
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="sm:text-sm lg:text-md font-bold me-2 text-gray-400">بازیگران:</span>;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t3 = actors.length > 0 ? actors.map((actor, i_0) => {
      const label_0 = actor.name_fa ?? actor.name_en ?? "\u2014";
      const nameSlug_0 = slugify(actor.name_en || actor.name_fa);
      const href_0 = actor.uuid ? `/crew/${actor.uuid}${nameSlug_0 ? `/${nameSlug_0}` : ""}` : "#";
      const key_0 = actor.uuid ?? `${label_0}-${i_0}`;
      return <span key={key_0}><Link href={href_0} className="hover:underline text-sm text-white">{label_0}</Link>{i_0 < actors.length - 1 && "\u060C "}</span>;
    }) : <span>-</span>;
    $[0] = stars;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t6 = <div className={t1}>{t2}{t3}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp2(person_0) {
  return person_0.role?.includes("directors");
}
function _temp(person) {
  return isCastLikeRole(person.role);
}